var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSortDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 592,
    height: 800,
    viewBox: "0 0 592 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.25 658.33C105.917 658.33 99.5833 655.997 94.5833 650.997L11.25 567.663C1.58333 557.997 1.58333 541.997 11.25 532.33C20.9167 522.663 36.9167 522.663 46.5833 532.33L112.25 597.997L177.917 532.33C187.583 522.663 203.583 522.663 213.25 532.33C222.917 541.997 222.917 557.997 213.25 567.663L129.917 650.997C124.917 655.997 118.583 658.33 112.25 658.33Z",
    fill: "#D3D3D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.25 658.333C98.5833 658.333 87.25 647 87.25 633.333V166.667C87.25 153 98.5833 141.667 112.25 141.667C125.917 141.667 137.25 153 137.25 166.667V633.333C137.25 647 125.917 658.333 112.25 658.333Z",
    fill: "#D3D3D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M562.25 575H295.583C281.916 575 270.583 563.667 270.583 550C270.583 536.333 281.916 525 295.583 525H562.25C575.916 525 587.25 536.333 587.25 550C587.25 563.667 575.916 575 562.25 575Z",
    fill: "#D3D3D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M428.916 375H295.583C281.916 375 270.583 363.667 270.583 350C270.583 336.333 281.916 325 295.583 325H428.916C442.583 325 453.916 336.333 453.916 350C453.916 363.667 442.583 375 428.916 375Z",
    fill: "#D3D3D3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M362.25 275H295.583C281.916 275 270.583 263.667 270.583 250C270.583 236.333 281.916 225 295.583 225H362.25C375.916 225 387.25 236.333 387.25 250C387.25 263.667 375.916 275 362.25 275Z",
    fill: "#D3D3D3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M495.583 475H295.583C281.916 475 270.583 463.667 270.583 450C270.583 436.333 281.916 425 295.583 425H495.583C509.25 425 520.583 436.333 520.583 450C520.583 463.667 509.25 475 495.583 475Z",
    fill: "#D3D3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSortDown);
export default __webpack_public_path__ + "static/media/ico_sort_down.4e1cd8b3f36b8f466f4f3a005b4f3756.svg";
export { ForwardRef as ReactComponent };